export const landingLayer = "landing";
export const mainSurveyLayer = "main-survey";
export const paymentLayer = "payment";
export const noomPremiumLayer = "noom-premium";
export const addonsLayer = "addons";
export const fastForwardLayer = "fast-forward";
export const enrollmentLayer = "enrollment";
